// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getWeek/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getWeekWithOptions = convertToFP(fn, 2);
export default getWeekWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getWeekWithOptions/index.js
// module id = 911
// module chunks = 0